var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMouse1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.738,
    height: 63.252,
    viewBox: "0 0 42.738 63.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21011",
    "data-name": "Group 21011",
    transform: "translate(19003.26 14258.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7670",
    "data-name": "Path 7670",
    d: "M166.478,10.925H155.74a16,16,0,0,0-16,16V58.177a16,16,0,0,0,16,16h10.738a16,16,0,0,0,16-16V26.925a16,16,0,0,0-16-16m-7.933,11.967a3.419,3.419,0,1,1,6.838,0V29.73a3.419,3.419,0,1,1-6.838,0Zm7.777,37.789-4.738,4.4-4.738-4.4h3.046V47.143h-3.046l4.738-4.4,4.738,4.4h-3.046V60.681Z",
    transform: "translate(-19143 -14269)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMouse1);
export default __webpack_public_path__ + "static/media/icon_mouse1.cfb78f60b927a9919bc4d3b086d36be1.svg";
export { ForwardRef as ReactComponent };